module.exports = ".btn-invisible\r\n{\r\n    visibility: hidden;\r\n}\r\n.no-padding\r\n{\r\n    padding:0px;\r\n}\r\n.alert-text{\r\n    color:red;\r\n}\r\n.left-padding\r\n{\r\n    padding-left: 5px;\r\n}\r\n.scroll-css\r\n{\r\n    overflow: auto;\r\n    max-height: 60vh;\r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/terms-of-use/terms-of-use.component.css
// module id = ./src/app/modules/terms-of-use/terms-of-use.component.css
// module chunks = main